/* eslint-disable import/prefer-default-export */
import { ControllerFieldState } from 'react-hook-form';

export const fieldHasError = (
  fieldState: ControllerFieldState
): fieldState is Required<ControllerFieldState> => !!fieldState.error;

export const fieldHasErrorMessage = (
  fieldState: ControllerFieldState
): fieldState is Required<ControllerFieldState> =>
  !!fieldState.error?.message?.length;
